import { useFormContext } from "react-hook-form";
import BodyDisplay from "./BodyDisplay";
import { IDataPublicos } from "../../../../../types/api/geral/pesquisar-publicos";

export default function Context() {
  //formulario
  const { getValues } = useFormContext();
  const defaultValueCliente: IDataPublicos = getValues("cliente");
  //

  return (
    <BodyDisplay
      tipo={defaultValueCliente.tipo_publico}
      codigo={Number(defaultValueCliente.codigo_publico)}
    />
  );
}
